import { css } from '@emotion/react';
import { useContextTranslation } from '@core/i18n';
import { Warning } from '@embed/components/VideoPlayer/Player3/assets/Warning';
import { PlayerButton } from '@player/components/PlayerButton';
import { ERROR_CONTENT_DESCRIPTION, ERROR_CONTENT_IMG, ERROR_CONTENT_OK_BUTTON, } from '@player/testIds';
import { Description, ErrorContentWrapper, Title } from './ErrorContent.styles';
/**
 * Content of Error modal Pass either footer (React element) or onDismiss
 * (callback) to render a dismiss button
 * @param
 *  - title: title of the error modal
 *  - description: description of the error modal
 *  - footer: React element to be rendered as footer
 *  - onDismiss: If no footer is passed, a dismiss button will be rendered.
 *  This callback will be called when the button is clicked
 *
 */
export const ErrorContent = ({ title, description, footer, onDismiss, }) => {
    const { t } = useContextTranslation();
    const DefaultFooter = () => (<PlayerButton data-testid={ERROR_CONTENT_OK_BUTTON} aria-label={t('player:Ok')} onClick={onDismiss}>
      {t('player:Ok')}
    </PlayerButton>);
    return (<ErrorContentWrapper>
      <Warning role="presentation" label={t('player:Warning icon')} width={58} height={58} data-testid={ERROR_CONTENT_IMG} css={css `
          margin-bottom: 25px;
        `}/>
      {title ? <Title>{title}</Title> : null}
      {description ? (<Description data-testid={ERROR_CONTENT_DESCRIPTION}>
          {description}
        </Description>) : null}
      {footer ? footer : <DefaultFooter />}
    </ErrorContentWrapper>);
};
